import * as React from "react";
const SvgLeftNormalLine = props => <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props}><path stroke="currentColor" d="M8.5 13.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 0H24" /></svg>;
export default SvgLeftNormalLine;